import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function SiteLayout() {
  const { pathname } = useLocation();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 420);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isHome = pathname === '/';

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader transparentTop={isHome} />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />

      <button
        type="button"
        aria-label="返回顶部"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`fixed right-4 md:right-6 bottom-6 z-40 w-11 h-11 rounded-full bg-primary-500 hover:bg-primary-600 text-foreground-950 flex items-center justify-center cursor-pointer transition-all duration-300 ${
          showTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <i className="ri-arrow-up-line text-lg" />
      </button>
    </div>
  );
}